export const PUBLIC_ROUTES = {
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  CODE_OF_CONDUCT: "/conduct",
};

export const routesWithoutRegisterButton = [
  PUBLIC_ROUTES.TERMS_AND_CONDITIONS,
  PUBLIC_ROUTES.CODE_OF_CONDUCT,
];
